import { lazy } from 'react'
import lazyLoad from './LazyLoad'

// 登录相关
export const orderRouter = [
  {
    element: lazyLoad(lazy(() => import('@/pages/order/deliverIndex'))),
    path: '/deliverList',
  },
  {
    element: lazyLoad(lazy(() => import('@/pages/order/deliverDetail'))),
    path: '/deliverDetail',
  },
  {
    element: lazyLoad(lazy(() => import('@/pages/order/orderIndex'))),
    path: '/orderList',
  },
  {
    element: lazyLoad(lazy(() => import('@/pages/order/orderDetail'))),
    path: '/orderDetail',
  },
  {
    element: lazyLoad(lazy(() => import('@/pages/order/orderStatus'))),
    path: '/orderStatus',
  }
  //
]